import ChatsBlock from "./chats-block";

export default ChatsBlock;